module.exports = __webpack_public_path__ + "img/Banner2-1_E.784fadbc.jpg";